/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DashboardLayout,
  DownloadButtonWrapper,
  OverlayDashboard,
  TopCardEngagement
} from "../CompanyEvents/styles";
import { toast } from "react-toastify";
import {setSelectedYear,} from "../../redux/actions";
import { fetchApi, commaSeperator } from "../../utils/methods";
// import YearDropdown from "../common/YearDropdown/YearDropdown";
import { TabContainer, TabViewNew } from "../ChallengeDetailsV2/styles";
import { Container } from "../ChallengeDashboardV2/CompletedChallenge/styles";
import { AddIconBranding } from "../../utils/icons";
import { Dropdown } from "react-bootstrap";
import {CardContainer} from './style';
import SkeletonLoder from "../common/skeletonLoder";
import { ImageUrl } from "../../utils/constants";
import { FetchWellnessCards, GetArticleCatgories, GetFitnessCatgories, GetRecipesCatgories, RecommendedWellnessQuizes, GetCompanyAdminRewardPeriods} from "../../redux/constants/apiConstants";
import {MuiltiDropdown} from '../common/commonStyles';
import RecommendedEvents from "../CompanyEvents/RecommendedEvents";
import AffirmationsComponent from "./AffirmationsComponent";
import HoverButton from "../common/HoverButton";
import ArticleComponent from "./ArticleComponent";
import FitnessComponent from "./FitnessComponent";
import RecipesComponent from "./RecipesComponent";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import dayjs from 'dayjs';
import ArchivedComponent from "./ArchivedComponent";

const WellnessAdminMain = (props) => {
  const {
    history,
    // yearList,
    //selectedYearInfo,
    // setSelectedYear,
    // role,
    companyInfo,
    allRoles
  } = props;

  // const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [WellnessData,setWellnessData]=useState([]);
  const [WellnessDataLoading,setWellnessDataLoading]=useState([]);
  const [QuizData,setQuizData]=useState([]);
  const [QuizDataLoading,setQuizDataLoading]=useState([]);
  // const dropdownRef = useRef();
  const [articleCategory, setArticleCategory] = useState([]);
  const [recipesCategory, setRecipesCategory] = useState([]);
  const [fitnessCategory, setFitnessCategory] = useState([]);

  const [articleLoading,setArticleLoading] = useState(false);
  const [recipesLoading,setRecipesLoading] = useState(false);
  const [fitnessLoading,setFitnessLoading] = useState(false);
  const isSuperAdmin = allRoles?.some((role) => role.rid === 3);
  const [rewardPeriodData, setRewardPeriodData] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  // const [periodDropdownOpen, setPeriodDropdownOpen] = useState(false);

  


  // const [subMenu, setSubmenu] = useState(0);


  const locationState = history?.location?.state;
  const [activeTab, setActiveTab] = useState(
    locationState?.activeTab || "Wellness"
  );
  
  const [activeLibraryTab, setActiveLibraryTab] = useState(
    locationState?.activeLibraryTab || "Affirmations"
  );
  // const [activeTab,setActiveTab]=useState("Wellness");
  // const [activeLibraryTab,setActiveLibraryTab]=useState("Affirmations");

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const fetchRewardPeriods = async () => {
    try {
      const res = await fetchApi(GetCompanyAdminRewardPeriods + '?company_id=' + companyInfo.id, "GET");
      if (res.status === 'success') {
        const periods = res.data?.periods || [];
        window.console.log("all periods:", JSON.stringify(periods));
        setRewardPeriodData(periods);
        // pick active period first, fallback to first in list
        const defaultPeriod = 
        periods.find((p) => p.status === 'active') || 
        periods.find((p) => p.status === 'completed') || 
        periods[0] || null;
        setSelectedPeriod(defaultPeriod);
        if (defaultPeriod) GetWellness(companyInfo?.id, defaultPeriod.reward_period_id);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  useEffect(()=>{
    // GetWellness(companyInfo?.id,selectedYearInfo);
    GetQuiz(companyInfo?.id);
    fetchRewardPeriods();
    // FetchWellnessHubCategory();
    FetchFitnessCategory();
    FetchRecipesCategory();
    FetchArticlesCategory();
    if (history.location?.state) {
      history.replace("/company/wellness", {}); // remove state after first use
    }

    
  },[])

  // const handleClickOutside = (event) => {
  //   if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
  //     setMenuIsOpen(false);
  //     setSubmenu(0)
  //   }
  // };

  // const handleSubmenu = (value) =>{
  //   setSubmenu(value)
  // }


  // const FetchWellnessHubCategory = async()=>{
  //   setWellnessLoading(true);
  //   try {
  //     const res = await fetchApi(GetWellnessHubCategories, "GET");
  //     if(res.status === 'success'){
  //       setWellnessLoading(false);
  //       setWellnessCategory({
  //         articles: res.data.article_categories || [],
  //         fitness: res.data.fitness_video_categories || [],
  //         recipes: res.data.recipe_categories || []
  //       });
  //     }else{
  //       setWellnessLoading(false);
  //       toast.error((res?.data?.message))
  //     }
  //   } catch (error) {
  //     window.console.error(error);
  //   }
  // }


  const FetchArticlesCategory = async()=>{
    setArticleLoading(true);
    try {
      const res = await fetchApi(GetArticleCatgories, "GET");
      if(res.status === 'success'){
        setArticleLoading(false);
        // setWellnessCategory(res.data)
        setArticleCategory(res.data)
      }else{
        setArticleLoading(false);
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const FetchRecipesCategory = async()=>{
    setRecipesLoading(true);
    try {
      const res = await fetchApi(GetRecipesCatgories, "GET");
      if(res.status === 'success'){
        setRecipesLoading(false);
        // setWellnessCategory(res.data)
        setRecipesCategory(res.data);
      }else{
        setRecipesLoading(false);
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }


  const FetchFitnessCategory = async()=>{
    setFitnessLoading(true);
    try {
      const res = await fetchApi(GetFitnessCatgories, "GET");
      if(res.status === 'success'){
        setFitnessLoading(false);
        // setWellnessCategory(res.data)
        setFitnessCategory(res.data);
      }else{
        setFitnessLoading(false);
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const GetWellness = async(companyId, rewardPeriodId) => {
    setWellnessDataLoading(true);
    const apiUrl = `${FetchWellnessCards}?company_id=${companyId}&reward_period_id=${rewardPeriodId}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.success === "success") {      // ← was res.status
        setWellnessDataLoading(false);
        setWellnessData(res?.data);
      } else {
        toast.error(res.message);
        setWellnessDataLoading(false);
      }
    } catch(error) {
      window.console.error(error);
      setWellnessDataLoading(false);
    }
  }




  const GetQuiz = async(id)=>{
    setQuizDataLoading(true);
    const apiUrl = RecommendedWellnessQuizes+"/"+id;
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setQuizDataLoading(false);
        setQuizData(res?.data);
      }else{
        toast.error(res.error);
        setQuizDataLoading(false);
      }
    }catch(error){
      window.console.error(error);
    }
  }
  // const fetchRewardPeriods = async () => {
  //   try {
  //     const res = await fetchApi(GetCompanyAdminRewardPeriods + '?company_id=' + companyInfo.id, "GET");
  //     if (res.status === 'success') {
  //       setRewardPeriodData(res.data?.periods || []);
  //       setSelectedPeriod(res.data?.periods?.[0] || null);
  //     } else {
  //       toast.error(res.message);
  //     }
  //   } catch (error) {
  //     window.console.error(error);
  //   }
  // };

  // const toggleMenu = () => {
  //   setMenuIsOpen((prevMenuIsOpen) => !prevMenuIsOpen);
  // };

  // const updateDropdown = (period) => {
  //   setSelectedPeriod(period);
  //   // pass the period to GetWellness if your API supports it, else keep using year
  //   GetWellness(companyInfo?.id, dayjs(period?.reward_start_date).format("YYYY"));
  // };

  const updateDropdown = (period) => {
    setSelectedPeriod(period);
    GetWellness(companyInfo?.id, period?.reward_period_id);
  };
  const fallBack = (e) => {
    e.target.src = "/public/images/default.png";
  };

  const showEngagementEmployeeDetail = () => {
    const EngagementEmployeeData = [
      {
        title: "Wellness",
        titleNew: "Engagement",
        value: "1",
        img: "/admin-wellness/wellnessE.png",
        text: "per user",
        color: "rgba(175, 135, 193, 1)",
        total: WellnessData?.[0]?.total_count,
        imageBackground: "rgba(168, 135, 193, 0.15)",
        subText: "Total Wellness Activities",
        average: WellnessData?.[0]?.average_count + " Activities",
      },
      {
        title: "Wellness Articles",
        titleNew: null,
        value: "2",
        img: "/admin-wellness/wellnessA.png",
        text: "per user",
        color: "rgba(103, 129, 195, 1)",
        total: WellnessData?.[1]?.total_count,
        average: WellnessData?.[1]?.average_count + " Articles",
        imageBackground: "rgba(103, 129, 195, 0.15)",
        subText: "Articles Read",
      },
      {
        title: "Fitness Videos",
        titleNew: null,
        value: "3",
        img: "/admin-wellness/fitness.png",
        text: "per user",
        color: "rgba(133, 192, 234, 1)",
        total: WellnessData?.[2]?.total_count,
        average: WellnessData?.[2]?.average_count + " Fitness Workouts",
        imageBackground: "rgba(133, 192, 234, 0.15)",
        subText: "Fitness Workouts Watched",
      },
      {
        title: "Recipe Videos",
        titleNew: null,
        value: "4",
        img: "/admin-wellness/recipe.png",
        text: "per user",
        color: "rgba(118, 171, 120, 1)",
        total: WellnessData?.[3]?.total_count,
        average: WellnessData?.[3]?.average_count + " Recipes",
        imageBackground: "rgba(118, 171, 120, 0.15)",
        subText: "Recipes Viewed",
      },
      {
        title: "Daily Tips",
        titleNew: null,
        value: "5",
        img: "/admin-wellness/tip.png",
        text: "per user",
        color: "#ffbf73",
        total: WellnessData?.[4]?.total_count,
        average: WellnessData?.[4]?.average_count + " Tips",
        imageBackground: "rgba(255, 191, 115, 0.15)",
        subText: "Tips Viewed",
      },
      {
        title: "Article Quizzes",
        titleNew: null,
        value: "6",
        img: "/admin-wellness/articleQuiz.png",
        text: "per user",
        color: "#dc94b5",
        total: WellnessData?.[5]?.total_count,
        average: WellnessData?.[5]?.average_count + " Article Quizzes",
        imageBackground: "rgba(220, 148, 181, 0.15)",
        subText: "Article Quizzes Passed",
      },
    ];
    return WellnessDataLoading ? (
      <React.Fragment>
        {" "}
        {EngagementEmployeeData.map((details, index) => (
          <SkeletonLoder
            width={"288px"}
            height={"180px"}
            key={index}
          ></SkeletonLoder>
        ))}
      </React.Fragment>
    ) : (
      EngagementEmployeeData?.map((details, index) => (
        <TopCardEngagement
          key={index}
          background={details?.imageBackground}
          color={details?.color}
          style={{ padding: "12px" }}
        >
          <div className="first-child">
            <div className="image">
              <img
                src={ImageUrl + details?.img}
                alt={"engagement-employee"}
                onError={fallBack}
              />
            </div>
            <div className="title">
              {details?.title}
              <br />
              {details?.titleNew}
            </div>
            <div className="infoIcon">
              {/* {this.infoDetails(details.info)} */}
              {/* <img src={ImageUrl + "/social-feed/info.png"} alt={"engagement-employee"} /> */}
            </div>
          </div>
          <div className="challengeData">
            <span className="value">{commaSeperator(details?.total)}</span>
            <span className="valueText">{details?.subText}</span>
          </div>

          <div
            className="borderCard"
            style={{ width: "100%", margin: "20px 0px" }}
          />

          <div className="last-child">
            <span className="participateText">
              {index === 3 ? "Average" : "Average"}
            </span>
            <span className="totalParticipant">{details?.average || ""}</span>
            <span className="participateText">{details?.text}</span>
          </div>
        </TopCardEngagement>
      ))
    );
  };
  return (
    <Container>
      <div className="mainContainer">
        <OverlayDashboard>
          <DashboardLayout>
            <TabContainer marginBottom="25px">
              <div style={{ display: 'flex', margin: 'auto auto auto 0px',width:'100%' }}>
                <TabViewNew
                  width
                  padding
                  // active={1}
                  margin={"8px"}
                  height="40px"
                  active={activeTab=="Wellness"?1:0}
                  onClick = {()=>setActiveTab("Wellness")}
                >
                  {"Wellness"}
                </TabViewNew>
                {isSuperAdmin ? <TabViewNew
                  width
                  padding
                  // active={1}
                  margin={"8px"}
                  height="40px"
                  onClick = {()=>setActiveTab("Library")}
                  active={activeTab=="Library"?1:0}
                >
                  {"Library"}
                </TabViewNew>:null}
                {isSuperAdmin ? <TabViewNew
                  width
                  padding
                  // active={1}
                  margin={"8px"}
                  height="40px"
                  onClick = {()=>setActiveTab("Archive")}
                  active={activeTab=="Archive"?1:0}
                >
                  {"Archive"}
                </TabViewNew>:null}
              </div>
              {activeTab === "Wellness" && rewardPeriodData.length ? (
                <div  style={{ display: 'flex', alignItems: 'center',  marginRight: '8px' }}>
                  <CommonDropdown
                    tileContainerStyle={{ width: "220px", padding: "0px", margin: "0px"}}
                    dropdownButtonPadding={"0px 35px 0px 12px"}
                    isRequired={true}
                    //dropdownOpen={periodDropdownOpen}
                    placeholder={"Period"}
                    title={
                      selectedPeriod
                        ? dayjs(selectedPeriod?.reward_start_date).format("MMM YYYY") +
                          " - " +
                          dayjs(selectedPeriod?.reward_end_date).format("MMM YYYY")
                        : ""
                    }
                    id="dropdown-wellness-period"
                    //onClick={() => setPeriodDropdownOpen(!periodDropdownOpen)}
                    onClick={() => {}}
                    data={rewardPeriodData}
                    active={selectedPeriod}
                    onSelectParameter={["year", "firstDate", "month"]}
                    itemValue={true}
                    valueIndex={0}
                    labelMargin={"0px"}
                    onSelect={updateDropdown}
                    dropIcon={true}
                    isManagerMargin={"0px"}
                    top={"8px"}
                    showDateRange={true}
                    dateRangeKeys={{
                      start: "reward_start_date",
                      end: "reward_end_date",
                    }}
                  />
                </div>
              ) : null}

              <MuiltiDropdown>
                {isSuperAdmin && activeTab !=="Wellness"  ? <DownloadButtonWrapper isEvent={true} marginLeft={"-117px"}>
                  <div className="create-events" style={{padding: "0px"}}>
                  
                    <Dropdown>
                      <Dropdown.Toggle>
                        <HoverButton
                          width="24px"
                          height="24px"
                          marginLeft="16px"
                          svgPath={AddIconBranding(24,24)} 
                          activeColor={"#DA6C74"} 
                          fillOpacity={1}
                          showTooltip={false}
                          inActiveColor={"#DA6C74"}
                          backgroundColor={"rgba(254, 254, 254, 0.60)"}
                          backgroundColorActive={"#DA6C74"}
                          title={"Create Affirmations"} />
                        
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => history.push({pathname:`/company/wellness/CreateAffirmationForm`,state:activeTab})}>
                        Create Affirmations
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname:`/education/create-category`,state: { from: "adminSide" }})} >Create Category</Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname:`/wellness-resources/create-article`,state:{route:"admin"}})} >Create Article</Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname:`/education/create-video`,state:{route:"admin"}})} >Create Fitness Videos</Dropdown.Item>
                        <Dropdown.Item onClick={() => history.push({pathname:`/wellness-resources/create-recipe`,state:{route:"admin"}})} >Create Recipe</Dropdown.Item> 
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </DownloadButtonWrapper>:null}
                {/* {role=="ADMIN"&&<div style={{padding: "0px"}} >
                  <Dropdown >
                    <Dropdown.Toggle>
                      <div style={{background:"rgba(0, 92, 135, 0.05)",padding:"8px",borderRadius:"4px", marginLeft:"8px"}}>{AdminEventsAddCreateEventButton()}</div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{width:"240px"}}>
                      <Dropdown.Item
                        onMouseEnter={() => handleSubmenu("article")}
                        onMouseLeave={() => handleSubmenu(false)}
                      >
                        Create Content

                        <svg
                          width="10"
                          height="16"
                          viewBox="0 0 10 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 8.00003C10 8.28678 9.87995 8.5735 9.64036 8.79212L2.09719 15.6718C1.61736 16.1094 0.839379 16.1094 0.359734 15.6718C-0.119911 15.2343 -0.119911 14.5249 0.359734 14.0872L7.03435 8.00003L0.359967 1.91279C-0.119678 1.47515 -0.119678 0.765811 0.359967 0.328387C0.839612 -0.109461 1.61759 -0.109461 2.09743 0.328387L9.6406 7.20793C9.88023 7.42666 10 7.71338 10 8.00003Z"
                            fill="#007AB1"
                          />
                        </svg>
                      </Dropdown.Item>
                      <hr/>
                      <Dropdown.Item
                        onMouseEnter={() => handleSubmenu("fitness")}
                        onMouseLeave={() => handleSubmenu(false)}
                      >
                        Create Category
                        <svg
                          width="10"
                          height="16"
                          viewBox="0 0 10 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 8.00003C10 8.28678 9.87995 8.5735 9.64036 8.79212L2.09719 15.6718C1.61736 16.1094 0.839379 16.1094 0.359734 15.6718C-0.119911 15.2343 -0.119911 14.5249 0.359734 14.0872L7.03435 8.00003L0.359967 1.91279C-0.119678 1.47515 -0.119678 0.765811 0.359967 0.328387C0.839612 -0.109461 1.61759 -0.109461 2.09743 0.328387L9.6406 7.20793C9.88023 7.42666 10 7.71338 10 8.00003Z"
                            fill="#007AB1"
                          />
                        </svg>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                    {subMenu=="article"&&<div className="sub-menu-wrapper" onMouseEnter={() => handleSubmenu("article")} onMouseLeave={() => handleSubmenu(false)}>
                      <div className="menuData">
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-adventure`)}
                        >
                          Add Article
                        </div>
                        <hr/>
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-video`)}
                        >
                          Add Fitness Video
                        </div>
                        <hr/>
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-recipe`)}
                        >
                          Add Recipe Video
                        </div>
                      </div>
                      <div className="leftcard" ></div>
                    </div>}
                    {subMenu=="fitness"&&<div className="sub-menu-wrapper" style={{position:"absolute", top:"100px"}} onMouseEnter={() => handleSubmenu("fitness")} onMouseLeave={() => handleSubmenu(false)}>
                      <div className="menuData">
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-category`)}
                        >
                          Article Category
                        </div>
                        <hr/>
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-video-category`)}
                        >
                          Fitness Category
                        </div>
                        <hr/>
                        <div className="sub-menu"
                          onClick={() => history.push(`/company/wellness/create-recipe-category`)}
                        >
                          Recipe Category
                        </div>
                      </div>
                      <div className="leftcard" ></div>
                    </div>}
                  </Dropdown>
                </div>} */}
              </MuiltiDropdown>
            </TabContainer>

            {activeTab=="Wellness" &&
            ( <>
              <CardContainer>
                {showEngagementEmployeeDetail()}
              </CardContainer>
              {QuizData?.length?<RecommendedEvents
                RecommendedEventData={QuizData}
                margin="60px"
                isQuizCard="1"
                history={history}
                heading={'Recommended Wellness Quizzes'}
                RecommendedEventDataLoading={QuizDataLoading}
              />:null}
            </>)}


            {activeTab === "Library" && (
              <div className="library-tabs">
                {["Affirmations","Articles","Fitness","Recipes"].map((tab) => (
                  <div
                    key={tab}
                    className={`library-tab ${
                      activeLibraryTab === tab ? "active" : ""
                    }`}
                    onClick={() => setActiveLibraryTab(tab)}
                  >
                    { tab}
                  </div>
                ))}
              </div>
            )}

            {activeTab === "Library" && (
              <>
                {activeLibraryTab === "Affirmations" && <AffirmationsComponent/>}
                {activeLibraryTab === "Articles" && <ArticleComponent categories={articleCategory}  wellnessLoading={articleLoading} />}
                {activeLibraryTab === "Fitness" && <FitnessComponent categories={fitnessCategory} wellnessLoading={fitnessLoading}/>}
                {activeLibraryTab === "Recipes" && <RecipesComponent categories={recipesCategory} wellnessLoading={recipesLoading}/>}
              </>
            )}



            {activeTab === "Archive" && (
              <div className="library-tabs">
                {["Articles","Fitness","Recipes"].map((tab) => (
                  <div
                    key={tab}
                    className={`library-tab ${
                      activeLibraryTab === tab ? "active" : ""
                    }`}
                    onClick={() => setActiveLibraryTab(tab)}
                  >
                    { tab}
                  </div>
                ))}
              </div>
            )}



            {activeTab === "Archive" && (
              <>
                {activeLibraryTab === "Articles" && <ArchivedComponent type="articles" categories={articleCategory}  wellnessLoading={articleLoading} />}
                {activeLibraryTab === "Fitness" && <ArchivedComponent  type="fitness" categories={fitnessCategory} wellnessLoading={fitnessLoading}/>}
                {activeLibraryTab === "Recipes" && <ArchivedComponent  type="recipes" categories={recipesCategory} wellnessLoading={recipesLoading}/>}
              </>
            )}




          </DashboardLayout>
        </OverlayDashboard>
      </div>
    </Container>
  );
};

WellnessAdminMain.defaultProps = {
  companyInfo: { id: 1, name: "" },
};

WellnessAdminMain.propTypes = {
  networkError: PropTypes.string,
  companyInfo: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  history: PropTypes.object,
  selectedYearInfo: PropTypes.number,
  yearList: PropTypes.array,
  setSelectedYear: PropTypes.func,
  user: PropTypes.object,
  t: PropTypes.func,
  userPermissions: PropTypes.array,
  allRoles: PropTypes.array,
};

const mapStateToProps = (state) => ({
  networkError: state.companyDashboard.networkError,
  selectedYearInfo: state.companyDashboard.selectedYearInfo,
  user: state.profileData.user,
  allRoles: state.profileData.allRoles,
  role: state.auth.role,
  userPermissions: state.profileData.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedYear: (year) => dispatch(setSelectedYear(year)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WellnessAdminMain);
